<template>
  <!-- 线下推广任务列表页面 -->
  <div class="container">
    <div class="handle-box-search">
      <div class="handle-box">
        <el-row class="head-search">
          <el-col :span="24">
            <span class="title">日期:</span>
            <el-date-picker
              v-model="search_data.month"
              type="month"
              placeholder="选择日期"
              format="yyyy-MM"
              value-format="yyyy-MM"
              style="width: 200px"
              @change="timeChange"
            >
            </el-date-picker>
          </el-col>
        </el-row>
      </div>
      <el-button @click="add_isShow = !add_isShow">添加</el-button>
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="searchGetPromotionTaskList"
        >搜索</el-button
      >
    </div>

    <el-table
      :data="tableData"
      style="width: 100%"
      ref="multipleTable"
      header-cell-class-name="table-header"
    >
      <el-table-column prop="title" label="推广标题" min-width="140">
      </el-table-column>

      <el-table-column prop="promotion_num" label="推广人数" min-width="100">
      </el-table-column>

      <el-table-column prop="join_num" label="已报名人数" min-width="100">
      </el-table-column>

      <el-table-column prop="join_stamp" label="报名时间" min-width="90">
      </el-table-column>
      <el-table-column prop="time_stamp" label="推广时间" min-width="90">
      </el-table-column>
      <el-table-column prop="status_des" label="状态" min-width="90">
      </el-table-column>
      <el-table-column prop="reward_amount" label="奖励" min-width="100">
        <template slot-scope="scope"
          >
          <div>
            {{scope.row.reward_monitor? "表现分:"+Number(scope.row.reward_monitor): ''}}
            </div>
            <div>
            {{scope.row.reward_amount?"现金:"+Number(scope.row.reward_amount):''}}
            </div>
            <div>
            {{scope.row.reward_priority_num?"优享券:"+Number(scope.row.reward_priority_num):''}}
            </div>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="280" align="center">
        <template slot-scope="scope">
          <el-button :disabled="scope.row.status_des =='推广中'||scope.row.status_des =='已结束'" type="primary" size="medium" @click="editBtn(scope.row)"
            >编辑
          </el-button>
          <!-- 查看报名人员按钮 -->
          <el-button type="" size="medium" @click="detail(scope.row)"
            >查看报名人员
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 查看组件 -->
    <joinTaskDriverList
      :isShow="view_isShow"
      :data="task_code"
    ></joinTaskDriverList>

    <!-- 添加组件 -->
    <addPromotionTask
      :isShow="add_isShow"
      @onSubmit="searchGetPromotionTaskList"
    ></addPromotionTask>

    <!-- 编辑组件 -->
    <editPromotionTask
      :isShow="edit_isShow"
      :data="editData"
      @onSubmit="searchGetPromotionTaskList"
    ></editPromotionTask>

    <!-- 分页组件 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="search_data.page"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="search_data.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="result_data.count"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
let _this;
import joinTaskDriverList from "./joinTaskDriverList.vue";
import addPromotionTask from "./addPromotionTask.vue";
import editPromotionTask from "./editPromotionTask.vue";

export default {
  components: {
    joinTaskDriverList,
    addPromotionTask,
    editPromotionTask,
  },

  watch: {
    isShow(newData, oldData) {
      _this.show = true;
      _this.searchGetPromotionTaskList();
    },
  },
  created() {
    _this = this;
    _this.searchGetPromotionTaskList();
  },

  data() {
    return {
      editData: {}, // 往编辑页面传数据
      add_isShow: false,
      edit_isShow: false,
      task_code: "",
      view_isShow: false,

      search_data: {
        page: 1,
        limit: 10,
        month: "",
      },

      tableData: [],
      result_data: {},
    };
  },
  methods: {
    editBtn(val) {
      _this.editData = val;
      _this.edit_isShow = !_this.edit_isShow;
    },
    detail(val) {
      _this.task_code = val.task_code;
      _this.view_isShow = !_this.view_isShow;
    },

    //下拉条（每页显示多少数据）变化
    handleSizeChange(val) {
      _this.search_data.limit = val;

      //初始化列表
      _this.pages_function();
    },
    //页码变化
    handleCurrentChange(val) {
      _this.search_data.page = val;
      //初始化列表
      _this.pages_function();
    },
    //翻页组件的回调
    pages_function() {
      //初始化列表
      console.log(666);
      _this.getPromotionTaskList();
    },

    // 搜索时间后直接搜索数据
    timeChange() {
      _this.searchGetPromotionTaskList();
    },
    searchGetPromotionTaskList() {
      _this.search_data.page = 1;
      _this.search_data.city_code = sessionStorage.getItem("city_code");

      _this.getPromotionTaskList();
    },
    getPromotionTaskList() {
      _this
        .$post("/Offlinepromotion/getPromotionTaskList", _this.search_data)
        .then((res) => {
          _this.result_data = res;
          _this.tableData = res.data;
        });
    },
  },
};
</script>

<style scoped>
.child {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}
.up {
  display: flex;
}
.left {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}
.amountNum {
  display: flex;
  justify-content: space-between;
  width: 30%;
  margin-bottom: 10px;
}
.line {
  background-color: #909399;
  width: 1px;
}
.child > div {
  margin-right: 20px;
  margin-bottom: 10px;
}
.pagination {
  text-align: right;
}
.handle-box {
  margin-bottom: 20px;
}

.handle-select {
  width: 120px;
}

.handle-input {
  max-width: 150px;
  display: inline-block;
}

.table {
  width: 100%;
  font-size: 14px;
}

.red {
  color: #ff0000;
}

.mr10 {
  margin-right: 10px;
}

.table-td-thumb {
  display: block;
  margin: auto;
  width: 40px;
  height: 40px;
}

.el-table__row {
  height: 100px;
}

.el-dropdown {
  vertical-align: top;
}

.el-dropdown + .el-dropdown {
  margin-left: 15px;
}

.el-icon-arrow-down {
  font-size: 12px;
}
</style>
